import { Currency } from "./currency";
import { LinkedAccount } from "@app/models/linked-account";

export class SavingAgreementApproval {
  id: string;
  savingAgreementNumber: string;
  type: string;
  status: string;
  name: string;
  description: string;
  interestRate: 0;
  savingAccountId: string;
  currency: Currency;
  startDate: string;
  closeDate: string;
  customerSpecificOptions: any[];
  initiatedUserId: string;
  initiatedUsername: string;
  channelCode: string;
  interestCalculationOption: string;
  interestPaymentPeriod: string;
  interestPaymentDay: number;
  savingAgreementNote: any[];
  branchId: string;
  interestRateCalculationOptions: any[];
  interestCalculationType: string;
  incomeTaxRate: number;
  productId: string;
  linkedAccount: LinkedAccount;
  interestCalculationTypeDays: 0
  savingAgreementTemplateDescription?: string;
  agreementNumber?: string;
  interestPaymentAccountNumber: string;
  correspondentAccountNumber: string;
}